import { createFileRoute } from '@tanstack/react-router'
import { StiRouteComponent } from '@/components/sti/StiRouteComponent'

export const Route = createFileRoute('/$location/services/sti/')({
	head: ({ params: { location } }) => ({
		meta:
			location === 'Fort-Lauderdale'
				? [
						{ title: 'Comprehensive STD Testing in Fort Lauderdale | Wellview Care' },
						{
							name: 'description',
							content:
								"Discover comprehensive STD testing, diagnosis, treatment, and education in Fort Lauderdale at Wellview Care. Learn why we're the trusted choice for expertise, confidentiality, cutting-edge testing, counseling, and support. Your sexual health is our priority.",
						},
						{
							name: 'keywords',
							content: 'STD Testing Fort Lauderdale, Sexual Health, Wellview Care',
						},
					]
				: location === 'Riviera-Beach'
					? [
							{
								title: 'Comprehensive STD Testing in Riviera Beach | Wellview Care',
							},
							{
								name: 'description',
								content:
									"Discover comprehensive STD testing, diagnosis, treatment, and education in Riviera Beach at Wellview Care. Learn why we're the trusted choice for expertise, confidentiality, cutting-edge testing, counseling, and support. Your sexual health is our priority.",
							},
							{
								name: 'keywords',
								content: 'STD Testing Riviera Beach, Sexual Health, Wellview Care',
							},
						]
					: location === 'Jacksonville'
						? [
								{ title: 'Comprehensive STD Testing in Jacksonville | Wellview Care' },
								{
									name: 'description',
									content:
										"Discover comprehensive STD testing, diagnosis, treatment, and education in Jacksonville at Wellview Care. Learn why we're the trusted choice for expertise, confidentiality, cutting-edge testing, counseling, and support. Your sexual health is our priority.",
								},
								{
									name: 'keywords',
									content: 'STD Testing Jacksonville, Sexual Health, Wellview Care',
								},
							]
						: location === 'Fort-Pierce'
							? [
									{ title: 'Comprehensive STD Testing in Fort Pierce | Wellview Care' },
									{
										name: 'description',
										content:
											"Discover comprehensive STD testing, diagnosis, treatment, and education in Fort Pierce at Wellview Care. Learn why we're the trusted choice for expertise, confidentiality, cutting-edge testing, counseling, and support. Your sexual health is our priority.",
									},
									{
										name: 'keywords',
										content: 'STD Testing Fort Pierce, Sexual Health, Wellview Care',
									},
								]
							: [
									{ title: 'Comprehensive STD Testing | Wellview Care' },
									{
										name: 'description',
										content:
											"Discover comprehensive STD testing, diagnosis, treatment, and education in Fort Lauderdale, Fort Pierce and Riviera Beach at Wellview Care. Learn why we're the trusted choice for expertise, confidentiality, cutting-edge testing, counseling, and support. Your sexual health is our priority.",
									},
									{
										name: 'keywords',
										content: 'STD Testing, Sexual Health, Riviera Beach, Fort Lauderdale, Fort Pierce Healthcare, Florida',
									},
								],
	}),
	component: StiRouteComponent,
})
